const NOTIFICATION_INFO = {
  AUTO_HIDE_DURATION: 3000,
  ERROR_MESSAGE: "Please Try Again Later",
  SUCESS_MESSAGE: "Created Successfully",
  DRAFT_MESSAGE: "Draft Created Successfully",
  EDIT_MESSAGE: "Updated Successfully",
  APPROVE_MESSAGE: "Approved / Rejected Successfully",
  CHECK_ALL_MANDATORY_FIELDS:
    "Please check all Cards and Fill Mandatory Fields",
  SAP_CONNECTION_ERROR: "Error while fetching SAP data",
  GENERATE_MESSAGE: "Generated Successfully",
  SAVED_MESSAGE: "Details Saved Successfully",
  NO_RECORDS_FOUND: "No Records Found",
  RELOAD_DATA: "Unknown Error Occured Please Reload",
};
export default {
  NOTIFICATION_INFO,
};
